/* Zeerjama 2.0 — storefront QA helpers */
(() => {
  const airSelector = '.AirReviews-Widget--Stars';

  const hideAirWidget = (widget) => {
    widget.hidden = true;
    widget.setAttribute('aria-hidden', 'true');
    widget.style.setProperty('display', 'none', 'important');
  };

  const showAirWidget = (widget) => {
    widget.hidden = false;
    widget.removeAttribute('aria-hidden');
    widget.style.removeProperty('display');
  };

  const enforceAirRating = (widget) => {
    if (!(widget instanceof Element) || !widget.matches(airSelector)) return;
    const average = Number.parseFloat(widget.dataset.reviewAvg || '');
    const count = Number.parseInt(widget.dataset.reviewCount || '0', 10);
    if (!Number.isFinite(average) || average < 4 || !Number.isFinite(count) || count < 1) hideAirWidget(widget);
    else showAirWidget(widget);
  };

  const enforceNativeRating = (scope) => {
    if (!(scope instanceof Element || scope instanceof Document)) return;
    const ratings = scope.matches?.('.card-information .rating') ? [scope] : Array.from(scope.querySelectorAll?.('.card-information .rating') || []);
    ratings.forEach((rating) => {
      const star = rating.querySelector('.rating-star');
      const whole = Number.parseFloat(star?.style.getPropertyValue('--rating') || '0');
      const decimal = Number.parseFloat(star?.style.getPropertyValue('--rating-decimal') || '0');
      const group = rating.parentElement;
      const countText = group?.querySelector('.rating-count')?.textContent || '';
      const countMatch = countText.match(/\d+/);
      const count = countMatch ? Number.parseInt(countMatch[0], 10) : 0;
      if (!Number.isFinite(whole + decimal) || whole + decimal < 4 || count < 1) {
        rating.style.setProperty('display', 'none', 'important');
        group?.querySelector('.rating-text')?.style.setProperty('display', 'none', 'important');
        group?.querySelector('.rating-count')?.style.setProperty('display', 'none', 'important');
      }
    });
  };

  const enforceWithin = (node) => {
    if (!(node instanceof Element || node instanceof Document)) return;
    if (node.matches?.(airSelector)) enforceAirRating(node);
    node.querySelectorAll?.(airSelector).forEach(enforceAirRating);
    const parentAir = node.closest?.(airSelector);
    if (parentAir) enforceAirRating(parentAir);
    enforceNativeRating(node);
  };

  const installSizeGuideStyles = () => {
    if (document.getElementById('zj-size-guide-modal-styles')) return;
    const style = document.createElement('style');
    style.id = 'zj-size-guide-modal-styles';
    style.textContent = `
      .zj-size-guide-modal-shell{overflow:hidden!important;background:rgba(31,8,20,.62)!important}
      .zj-size-guide-modal-shell .product-popup-modal__content{width:min(620px,calc(100% - 28px))!important;height:auto!important;max-height:min(78dvh,680px)!important;top:50%!important;left:50%!important;margin:0!important;transform:translate(-50%,-50%)!important;padding:0!important;overflow:auto!important;background:#fffaf7!important;border:1px solid rgba(83,6,47,.14)!important;border-radius:28px!important;box-shadow:0 30px 90px rgba(52,5,31,.26)!important;animation:zjSizeGuideIn .22s ease-out both}
      .zj-size-guide-modal-shell .product-popup-modal__content:focus,.zj-size-guide-modal-shell .product-popup-modal__content:focus-visible{outline:none!important;box-shadow:0 30px 90px rgba(52,5,31,.26)!important}
      .zj-size-guide-modal-shell .product-popup-modal__toggle{position:absolute!important;top:18px!important;right:18px!important;margin:0!important;width:46px!important;height:46px!important;padding:0!important;display:flex!important;align-items:center!important;justify-content:center!important;background:#fff!important;color:#53062f!important;border:1px solid rgba(83,6,47,.12)!important;box-shadow:0 8px 24px rgba(52,5,31,.08)!important;z-index:3!important}
      .zj-size-guide-modal-shell .product-popup-modal__toggle:hover{background:#fff1f5!important;color:#34051f!important}
      .zj-size-guide-modal-shell .product-popup-modal__toggle .icon{width:18px!important;height:18px!important}
      .zj-size-guide-modal-shell .product-popup-modal__content-info{padding:34px 28px 28px!important;padding-right:28px!important;color:#321020!important}
      .zj-size-guide-modal__eyebrow{display:inline-flex!important;align-items:center!important;min-height:30px!important;margin:0 58px 14px 0!important;padding:6px 11px!important;border-radius:999px!important;background:#fff1f5!important;color:#7c234e!important;font-size:11px!important;line-height:1!important;font-weight:800!important;letter-spacing:.13em!important;text-transform:uppercase!important}
      .zj-size-guide-modal__title{margin:0 54px 12px 0!important;font-family:Georgia,'Times New Roman',serif!important;font-size:32px!important;line-height:1.08!important;letter-spacing:-.025em!important;color:#321020!important;font-weight:700!important}
      .zj-size-guide-modal-shell .product-popup-modal__content-info>p:not(.zj-size-guide-modal__eyebrow){margin:0 0 20px!important;color:#765f69!important;font-size:16px!important;line-height:1.62!important;letter-spacing:0!important}
      .zj-size-guide-modal__steps{display:grid!important;grid-template-columns:repeat(3,minmax(0,1fr))!important;gap:9px!important;margin:4px 0 20px!important}
      .zj-size-guide-modal__step{min-width:0!important;padding:13px 10px!important;border:1px solid rgba(83,6,47,.10)!important;border-radius:15px!important;background:#fff!important;text-align:left!important}
      .zj-size-guide-modal__step-number{display:flex!important;width:25px!important;height:25px!important;margin:0 0 9px!important;align-items:center!important;justify-content:center!important;border-radius:50%!important;background:#53062f!important;color:#fff!important;font-size:11px!important;font-weight:800!important}
      .zj-size-guide-modal__step strong{display:block!important;margin:0 0 2px!important;color:#321020!important;font-size:13px!important;line-height:1.25!important}
      .zj-size-guide-modal__step span:last-child{display:block!important;color:#765f69!important;font-size:11.5px!important;line-height:1.3!important}
      .zj-size-guide-modal__cta{display:flex!important;width:100%!important;min-height:52px!important;align-items:center!important;justify-content:center!important;gap:10px!important;padding:12px 18px!important;border:0!important;border-radius:999px!important;background:#53062f!important;color:#fff!important;text-decoration:none!important;font-size:15px!important;line-height:1.2!important;font-weight:800!important;box-shadow:none!important;transition:background .2s ease,transform .2s ease!important}
      .zj-size-guide-modal__cta:hover{background:#34051f!important;transform:translateY(-1px)!important}
      .zj-size-guide-modal__cta:focus-visible{outline:3px solid rgba(157,38,86,.28)!important;outline-offset:3px!important}
      .zj-size-guide-modal__cta-arrow{font-size:19px!important;line-height:1!important}
      @keyframes zjSizeGuideIn{from{opacity:0;transform:translate(-50%,calc(-50% + 14px)) scale(.985)}to{opacity:1;transform:translate(-50%,-50%) scale(1)}}
      @media screen and (max-width:480px){
        .zj-size-guide-modal-shell .product-popup-modal__content{width:calc(100% - 24px)!important;max-height:82dvh!important;border-radius:24px!important}
        .zj-size-guide-modal-shell .product-popup-modal__content-info{padding:27px 20px 22px!important}
        .zj-size-guide-modal-shell .product-popup-modal__toggle{top:14px!important;right:14px!important;width:44px!important;height:44px!important}
        .zj-size-guide-modal__eyebrow{margin-right:52px!important;margin-bottom:13px!important;font-size:10.5px!important}
        .zj-size-guide-modal__title{margin-right:48px!important;font-size:28px!important}
        .zj-size-guide-modal-shell .product-popup-modal__content-info>p:not(.zj-size-guide-modal__eyebrow){font-size:15px!important;line-height:1.55!important;margin-bottom:17px!important}
        .zj-size-guide-modal__steps{gap:7px!important;margin-bottom:18px!important}
        .zj-size-guide-modal__step{padding:11px 8px!important;border-radius:13px!important}
        .zj-size-guide-modal__step-number{width:23px!important;height:23px!important;margin-bottom:8px!important}
        .zj-size-guide-modal__step strong{font-size:12px!important}
        .zj-size-guide-modal__step span:last-child{font-size:10.5px!important}
      }
      @media (prefers-reduced-motion:reduce){.zj-size-guide-modal-shell .product-popup-modal__content{animation:none!important}.zj-size-guide-modal__cta{transition:none!important}}
    `;
    document.head.appendChild(style);
  };

  const findSizeGuideModal = () => {
    const direct = document.getElementById('PopupModal-size_guide');
    if (direct) return direct;
    return Array.from(document.querySelectorAll('modal-dialog.product-popup-modal')).find((modal) => {
      const heading = modal.querySelector('.product-popup-modal__content-info h1');
      return /size\s*guide/i.test(heading?.textContent || '');
    }) || null;
  };

  const enhanceSizeGuideModal = () => {
    const modal = findSizeGuideModal();
    if (!modal || modal.dataset.zjSizeGuideEnhanced === 'true') return;
    const info = modal.querySelector('.product-popup-modal__content-info');
    const heading = info?.querySelector('h1');
    if (!info || !heading) return;

    modal.classList.add('zj-size-guide-modal-shell');
    heading.textContent = 'Find your best starting size';
    heading.classList.add('zj-size-guide-modal__title');

    const eyebrow = document.createElement('p');
    eyebrow.className = 'zj-size-guide-modal__eyebrow';
    eyebrow.textContent = 'Size help · Find your fit';
    info.insertBefore(eyebrow, heading);

    const steps = document.createElement('div');
    steps.className = 'zj-size-guide-modal__steps';
    steps.setAttribute('aria-label', 'Size guide steps');
    steps.innerHTML = `
      <div class="zj-size-guide-modal__step"><span class="zj-size-guide-modal__step-number">1</span><strong>Underbust</strong><span>Measure snugly</span></div>
      <div class="zj-size-guide-modal__step"><span class="zj-size-guide-modal__step-number">2</span><strong>Bust</strong><span>Measure fullest point</span></div>
      <div class="zj-size-guide-modal__step"><span class="zj-size-guide-modal__step-number">3</span><strong>Starting size</strong><span>Compare your fit</span></div>
    `;
    info.appendChild(steps);

    const cta = document.createElement('a');
    cta.className = 'zj-size-guide-modal__cta';
    cta.href = '/pages/size-guide';
    cta.innerHTML = '<span>Open interactive size guide</span><span class="zj-size-guide-modal__cta-arrow" aria-hidden="true">→</span>';
    info.appendChild(cta);

    modal.dataset.zjSizeGuideEnhanced = 'true';
  };

  const enforceAll = () => enforceWithin(document);

  const start = () => {
    enforceAll();
    installSizeGuideStyles();
    enhanceSizeGuideModal();
    [250, 800, 1600, 3000].forEach((delay) => window.setTimeout(() => {
      enforceAll();
      enhanceSizeGuideModal();
    }, delay));

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.target instanceof Element) enforceWithin(mutation.target);
        mutation.addedNodes.forEach((node) => {
          if (node instanceof Element) enforceWithin(node);
        });
      });
      enhanceSizeGuideModal();
    });
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-review-avg', 'data-review-count'] });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
